import { render, staticRenderFns } from "./buySim.vue?vue&type=template&id=7b8694fc&scoped=true"
import script from "./buySim.vue?vue&type=script&lang=js"
export * from "./buySim.vue?vue&type=script&lang=js"
import style0 from "./buySim.vue?vue&type=style&index=0&id=7b8694fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8694fc",
  null
  
)

export default component.exports